import Vue from "vue";
import Router from "vue-router";

// router懒加载
// const selection = resolve => require(["@/page/selection"], resolve);
// const selectionMobile = resolve => require(["@/page/selectionMobile"], resolve);
const summit = resolve => require(["@/page/summit"], resolve);
const summitMobile = resolve => require(["@/page/summitMobile"], resolve);
const person = resolve => require(["@/page/person"], resolve);
const personMobile = resolve => require(["@/page/personMobile"], resolve);
const activity = resolve => require(["@/page/activity"], resolve);
// const vote = resolve => require(["@/page/vote"], resolve);
const activityMobile = resolve => require(["@/page/activityMobile"], resolve);
const irtopPc = resolve => require(["@/page/irtop"], resolve);
const irtopMobile = resolve => require(["@/page/irtopMobile"], resolve);
const layout = resolve => require(["@/layout/default"], resolve);

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "selection",
      redirect: { name: "selection" },
      component: layout,
      children: [
        {
          path: "/selectionPc",
          name: "selectionPc",
          // component: selection,
          meta: {
            title:'重磅揭晓|第五届中国卓越IR评选最终获奖名单发布！'
          },
          component: summit
        },
        {
          path: "/selection",
          name: "selection",
          // component: selectionMobile,
          component: summitMobile,
          meta: {
            // keepAlive: true, // 需要被缓存
            title:'重磅揭晓|第五届中国卓越IR评选最终获奖名单发布！'
          }
        },
        // {
        //   path: "/votePc",
        //   name: "vote",
        //   component: vote,
        //   meta: {
        //   }
        // },
        {
          path: "/summitPc",
          name: "summitPc",
          // component: summit
          component: summit,
          meta: {
            title:"重磅揭晓|第五届中国卓越IR评选最终获奖名单发布！"
          }
        },
        {
          path: "/summit",
          name: "summit",
          component: summitMobile,
          meta: {
             keepAlive: true, // 需要被缓存
            title:'重磅揭晓|第五届中国卓越IR评选最终获奖名单发布！'
          }
        },
        {
          path: "/personPc",
          name: "personPc",
          component: person,
          meta: {
            title:'重磅揭晓|第五届中国卓越IR评选最终获奖名单发布！'
          }
        },
        {
          path: "/person",
          name: "person",
          component: personMobile,
          meta: {
            title:'重磅揭晓|第五届中国卓越IR评选最终获奖名单发布！'
          }
        },
        {
          path: "/activityPc",
          name: "activityPc",
          component: activity,
          meta: {
            title:'“Ready就绪”2022上市公司投资者关系创新峰会暨第五届中国卓越IR颁奖盛典'
          }
        },
        {
          path: "/activity",
          name: "activity",
          component: activityMobile,
          meta: {
            title:'“Ready就绪”2022上市公司投资者关系创新峰会暨第五届中国卓越IR颁奖盛典'
          }
        },
        {
          path: "/irtopPc",
          name: "irtopPc",
          component: irtopPc,
          meta: {
            title:'重磅揭晓|第五届中国卓越IR评选最终获奖名单发布！'
          }
        },
        {
          path: "/irtop",
          name: "irtop",
          component: irtopMobile,
          meta: {
            title:'重磅揭晓|第五届中国卓越IR评选最终获奖名单发布！'
          }
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => { 
  // console.log(to,'router.beforeEach')
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js